import type { BlindMapCentroid } from './blind-map'

export const DEFAULT_US_CENTROID: BlindMapCentroid = { lat: 39.8283, lng: -98.5795 }
export const DEFAULT_US_ZOOM = 4
